<template>
  <sfs-form-modal
    :id="modalId"
    title="Add an Item"
    @on-hide="resetFormData"
  >
    <supply-order-item-form
      @on-submit="createItem"
      @on-save="onSave"
      @on-cancel="closeModal"
      :vendor_id="vendor_id"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import SupplyOrderItemForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'SupplyOrderItemAddModal',
  mixins: [formModalMixin],
  components: {
    SupplyOrderItemForm,
  },
  props: {
    supply_order_id: { type: Number, required: true },
    vendor_id: { type: Number, required: true },
  },
  data() {
    return {
      modalId: 'supply-order-item-add-modal',
    };
  },
  methods: {
    createItem(data, handleCreate) {
      handleCreate(this.$supplyOrdersAPI.createItem(this.supply_order_id, data));
    },
    onSave() {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save');
    },
  },
};
</script>
